import { Form, Row, Col, Input } from "antd";
import React from "react";
import BannerCard from "../../../common/components/BannerCard";
import CleanButton from "../../../common/components/CleanButton";
import InputFields from "../../../common/components/InputFields";
import getConfigs from "../../../GetConfigs";

const CivilDefendantDetail = ({ ...props }) => {
  const { form } = props;
  const configurations = getConfigs([
    "cvAttorneyPhone",
    "cvPlaintiffDefendantAddr"
  ]);
  return (
    <BannerCard title="Defendant Details">
      <Form form={form} layout="vertical">
        <Row gutter={16}>
          <InputFields.InputTextField responsiveOptions={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 24 }} formItemName="PrimaryDefendantName" formItemLabel="Name" condition="Y" />
          <InputFields.InputTextField
            responsiveOptions={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 24 }}
            formItemName="PrimaryDefendantPhysicalAddress1"
            formItemLabel="Address"
            condition={configurations.cvPlaintiffDefendantAddr}
          />
          <InputFields.InputTextField responsiveOptions={{ xl: 8, lg: 8, md: 8, sm: 8, xs: 24 }} formItemName="PrimaryDefendantPhysicalCity" formItemLabel="City" condition={configurations.cvPlaintiffDefendantAddr} />
          <InputFields.InputTextField responsiveOptions={{ xl: 8, lg: 8, md: 8, sm: 8, xs: 24 }} formItemName="PrimaryDefendantPhysicalState" formItemLabel="State" condition={configurations.cvPlaintiffDefendantAddr} />
          <InputFields.InputTextField responsiveOptions={{ xl: 8, lg: 8, md: 8, sm: 8, xs: 24 }} formItemName="PrimaryDefendantPhysicalZipCode" formItemLabel="Zip" condition={configurations.cvPlaintiffDefendantAddr} />
          <InputFields.InputTextField responsiveOptions={{ xl: 8, lg: 8, md: 8, sm: 8, xs: 24 }} formItemName="DefendantAttorneyName" formItemLabel="Attorney Name" condition="Y" />
          <InputFields.InputTextField responsiveOptions={{ xl: 8, lg: 8, md: 8, sm: 8, xs: 24 }} formItemName="DefendantAttorneyPhone" formItemLabel="Attorney Phone" condition={configurations.cvAttorneyPhone} />
          <Col xl={8} lg={8} md={8} sm={8} xs={24}>
            <Form.Item name="DefendantCount" label="Defendant Count">
              <CleanButton icon="eye" type="link" block onClick={() => props.setActiveKey("6")}>
                {props.civilMaster?.summary?.MAIN[0]?.DefendantCount}
              </CleanButton>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </BannerCard>
  );
};

export default CivilDefendantDetail;
